// www.app.fin-tracks.com/session/signin/?signature=zaed-ji5g-fptb-epl0
// www.app.fin-tracks.com/session/signin/?signature=nbcs-tgqi-j6de-weda

import HARDCODE from '../../../business-const/HardCode/HardCode'



const codigoPromocionalList = [
    {
        id: 'b1mh-wqid-qe9j-xa00',
        //descricao: 'Sincor-SP',
        grupo: 'SINCOR-SP',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 10,
    },
    {
        id: 'b1sh-wqi2-qr9j-xao0',
        //descricao: 'Sincor-SP',
        grupo: 'SINCOR-SP-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 10,
    },
    {
        id: 'ab9i-uegs-qplw-mv3t',
        //descricao: 'ABAAI',
        grupo: 'ABAAI',
        //subgrupo: 'JAN25',
        //dataAssinaturaAte: '2025-01-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 15,
    },
    {
        id: 'zket-p0iy-tqit-ryw0',
        //descricao: '',
        grupo: 'PLANEJAR',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 20,
    },
    {
        id: 'zart-pyuj-tqlf-io30',
        //descricao: '',
        grupo: 'PLANEJAR-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 30,
    },
    {
        id: 'zart-njgr-tqlf-lpa0',
        //descricao: '',
        grupo: 'PLANEJAR-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 40,
    },
    {
        id: 'zart-hyul-tqlf-e4w0',
        //descricao: '',
        grupo: 'PLANEJAR-03',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 50,
    },
    {
        id: 'hnfj-kqan-4fpo-dkeq',
        //descricao: '',
        grupo: 'PLANEJAR-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 52,
    },
    {
        id: 'jutg-loxw-9kjr-pqad',
        //descricao: '',
        grupo: 'PLANEJAR-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 54,
    },
    {
        id: 'zart-p9uy-tqlf-rbs0',
        //descricao: '',
        grupo: 'PLANEJARW',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 55,
    },
    {
        id: 'hnvj-kqrs-iypo-poex',
        //descricao: '',
        grupo: 'PLANEJARW-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 56,
    },
    {
        id: 'juju-iybx-lo9r-pgfd',
        //descricao: '',
        grupo: 'PLANEJARW-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 57,
    },
    {
        id: 'kjif-ju87-loev-heqm',
        //descricao: '',
        grupo: 'ROGERIOSALTES',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 58,
    },
    {
        id: 'kbqp-jgbs-1rnm-loew',
        //descricao: '',
        grupo: 'ROGERIOSALTES-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 59,
    },
    {
        id: 'logb-4fdw-oqjf-pmrx',
        //descricao: '',
        grupo: 'ROGERIOSALTES-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 60,
    },
    {
        id: 'zaed-ji5g-fptb-epl0',
        //descricao: '',
        grupo: 'FIN-TRACKS',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 65,
    },
    {
        id: 'ushd-lp9ic-4euvb-kf40',
        //descricao: '',
        grupo: 'FIN-TRACKS-FA',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 70,
    },
    {
        id: 'h6qd-plet-0igb-l6t0',
        //descricao: '',
        grupo: 'FIN-TRACKS-JP',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 80,
    },
    {
        id: 'jeod-q2be-lskb-kw70',
        //descricao: '',
        grupo: 'FIN-TRACKS-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 90,
    },
    {
        id: 'jqed-t5uw-p9rb-oh30',
        //descricao: '',
        grupo: 'FIN-TRACKS-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 100,
    },
    {
        id: 'ahed-otbu-5tfb-lwa0',
        //descricao: '',
        grupo: 'FIN-TRACKS-03',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 110,
    },
    {
        id: 'korq-xv3w-9iur-lli0',
        //descricao: '',
        grupo: 'FIN-TRACKS-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 115,
    },
    {
        id: 'ncpd-7gea-i9ub-awq0',
        //descricao: '',
        grupo: 'MVMAGNETO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 120,
    },
    {
        id: 'o9id-taud-ikob-hge0',
        //descricao: 'Gustavo Chelotti',
        grupo: 'CHELOTTI',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 130,
    },
    {
        id: 'o9je-tokd-ilob-hg3d',
        //descricao: 'Gustavo Chelotti',
        grupo: 'CHELOTTI-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 135,
    },
    {
        id: 'p0ty-jeyq-hqes-2gm0',
        //descricao: 'Cintia Germano',
        grupo: 'CINTIAGERMANO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 140,
    },
    {
        id: 'p0ty-jeyq-hqes-2gm0',
        //descricao: 'Cintia Germano - 02',
        grupo: 'CINTIAGERMANO-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 142,
    },
    {
        id: 'bnef-p9ue-koi8-rbs0',
        //descricao: '',
        grupo: 'FERNANDA',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 150,
    },
    {
        id: 'oi3e-pyuh-j8fr-io30',
        //descricao: '',
        grupo: 'FERNANDA-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 160,
    },
    {
        id: 'cao7-njgo-href-lpa0',
        //descricao: '',
        grupo: 'FERNANDA-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 170,
    },
    {
        id: 'lpou-hyuf-ht6w-e4w0',
        //descricao: '',
        grupo: 'FERNANDA-03',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 180,
    },
    {
        id: 'bner-p0ue-kor8-rty0',
        //descricao: '',
        grupo: 'MINERVINI',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 190,
    },
    {
        id: 'oi8e-pheh-j9or-ijj0',
        //descricao: '',
        grupo: 'MINERVINI-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 200,
    },
    {
        id: 'c6y7-nqao-hrut-ljai',
        //descricao: '',
        grupo: 'MINERVINI-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 210,
    },
    {
        id: 'ater-z0ye-ko8i-uehd',
        //descricao: '',
        grupo: 'PAVAO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 220,
    },
    {
        id: 'ueyh-p7uh-aaor-ytw0',
        //descricao: '',
        grupo: 'PAVAO-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 230,
    },
    {
        id: 'nvxa-ujet-h78t-lpot',
        //descricao: '',
        grupo: 'PAVAO-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 240,
    },
    {
        id: 'nloa-upwt-iutt-lpoe',
        //descricao: '',
        grupo: 'PAVAO-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 242,
    },
    {
        id: 'uiue-p8hq-iupw-lofp',
        //descricao: '',
        grupo: 'FELIX',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 245,
    },
    {
        id: 'ueue-p9hq-iuvw-lofz',
        //descricao: '',
        grupo: 'FELIX-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 250,
    },
    {
        id: 'iyte-olmn-yhgw-6yhw',
        //descricao: '',
        grupo: 'FELIX-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 260,
    },
    {
        id: 'ugte-poi8-ipte-lqse',
        //descricao: '',
        grupo: 'FELIX-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 265,
    },
    {
        id: 'hbtg-lqsa-5rte-oyrc',
        //descricao: '',
        grupo: 'FIN-TRACKS-PREV-FA',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        tipoLicenca: HARDCODE.tipoLicencaPrevidenciaPrivada,
        ordem: 270,
    },
    {
        id: 'hyef-8jke-axwq-lbdf',
        //descricao: '',
        grupo: 'FIN-TRACKS-PREV-MV',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        tipoLicenca: HARDCODE.tipoLicencaPrevidenciaPrivada,
        ordem: 280,
    },
    {
        id: 'jyge-9iue-leha-plew',
        //descricao: '',
        grupo: 'FIN-TRACKS-PREV-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        tipoLicenca: HARDCODE.tipoLicencaPrevidenciaPrivada,
        ordem: 290,
    },
    {
        id: 'nbcs-tgqi-j6de-weda',
        //descricao: '',
        grupo: 'FIN-TRACKS-PREV-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        tipoLicenca: HARDCODE.tipoLicencaPrevidenciaPrivada,
        ordem: 300,
    },
    {
        id: 'gfrs-pol5-qwnc-jtel',
        //descricao: '',
        grupo: 'EXPERT-XP',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 310,
    },
    {
        id: 'juoe-hgwq-lpoe-4dvb',
        //descricao: '',
        grupo: 'MANTUAN-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 310,
    },
    {
        id: 'jupe-hgiq-lpae-4dgb',
        //descricao: '',
        grupo: 'MANTUAN-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 315,
    },
    {
        id: 'jjue-fqpl-nbaw-9uts',
        //descricao: '',
        //grupo: 'BIANCA-02',
        grupo: 'BIANCA-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 320,
    },
    {
        id: 'jhne-powq-adby-5tgy',
        //descricao: '',
        grupo: 'ALBERTO-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 320,
    },
    {
        id: 'kjud-hnte-ki8p-wapk',
        //descricao: '',
        grupo: 'BRITIS',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 330,
    },
    {
        id: 'kjod-hkee-ka8x-wept',
        //descricao: '',
        grupo: 'BRITIS-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 340,
    },
    //{
    //    id: 'jekq-ponv-4res-2qft',
    //    //descricao: '',
    //    grupo: 'BRITIS-02',
    //    //subgrupo: 'DEZ24',
    //    //dataAssinaturaAte: '2024-12-31 00:00:00',
    //    subgrupo: 'MAR25',
    //    dataAssinaturaAte: '2025-03-31 00:00:00',
    //    ordem: 350,
    //},
    {
        id: 'jekq-ponv-4res-2qft',
        //descricao: '',
        grupo: 'RODRIGO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 360,
    },
    {
        id: 'dhju-1eft-tgyu-zasm',
        //descricao: '',
        grupo: 'PIETRO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 370,
    },
    {
        id: 'dhjd-1oft-tpyu-znsm',
        //descricao: '',
        grupo: 'PIETRO-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 372,
    },
    {
        id: 'djur-badw-loer-4tyu',
        //descricao: '',
        grupo: 'PIETRO-07',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 374,
    },
    {
        id: 'dddu-3oit-jrhy-z9im',
        //descricao: '',
        grupo: 'JESSICA',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 376,
    },
    {
        id: 'nhy5-jey7-sqpl-aabe',
        //descricao: '',
        grupo: 'JESSICA-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 378,
    },
    {
        id: 'kute-nhga-lpoq-nmdh',
        //descricao: '',
        grupo: 'JESSICA-02',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 380,
    },
    {
        id: 'hgye-lpoy-aheh-3yhf',
        //descricao: '',
        grupo: 'GILDSON-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 382,
    },
    {
        id: 'lgde-arqp-dkmn-4g1e',
        //descricao: '',
        grupo: 'LEOLEITE-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 390,
    },
    {
        id: 'lhee-ao0p-kqmn-4gpr',
        //descricao: '',
        grupo: 'WANESSAG-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 400,
    },
    {
        id: 'nvla-uoet-huet-l1kt',
        //descricao: '',
        grupo: 'MMESQUITA-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 410,
    },
    {
        id: 'qers-louj-anbe-lpca',
        //descricao: '',
        grupo: 'BENSCO-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 420,
    },
    {
        id: 'jupe-htfw-lpbc-5tgu',
        //descricao: '',
        grupo: 'RENANBORGES-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 430,
    },
    {
        id: 'ahei-kueq-plou-3rfw',
        //descricao: '',
        grupo: 'RENANBORGES-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 440,
    },
    {
        id: 'kjeu-bnvs-5hge-lpot',
        //descricao: '',
        grupo: 'BRUNOGUIMARAES-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 445,
    },
    {
        id: 'dpja-1fuw-3gu2-ktba',
        //descricao: '',
        grupo: 'MATEUSNICOLAU',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 450,
    },
    {
        id: 'aloi-kplk-ncau-uyr2',
        //descricao: '',
        grupo: 'EDL-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 460,
    },
    {
        id: 'iyhe-ku3t-lpwd-ambc',
        //descricao: '',
        grupo: 'FIN-TRACKS-07',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 470,
    },
    {
        id: 'ijye-loit-3rte-lopw',
        //descricao: '',
        grupo: 'FIN-TRACKS-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 475,
    },
    {
        id: 'iyhy-kuot-ppwd-iebc',
        //descricao: '',
        grupo: 'MARLON',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 480,
    },
    {
        id: 'ihry-pefr-gwsa-lpoe',
        //descricao: '',
        grupo: 'MARLON-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 480,
    },
    {
        id: 'jwhu-qsaw-lnbs-2euf',
        //descricao: '',
        grupo: 'ADEMIR-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 480,
    },
    {
        id: 'jije-sdfe-3dge-ki9i',
        //descricao: '',
        grupo: 'PEDROMADURO-01',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 480,
    },
    {
        id: 'ahey-lowq-8jhr-bcxs',
        //descricao: '',
        grupo: 'MENEGATTO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 490,
    },
    {
        id: 'ajuy-kmjr-p09y-nbet',
        //descricao: '',
        grupo: 'MENEGATTO-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 500,
    },
    {
        id: 'nbrh-jhrp-1dre-mewi',
        //descricao: '',
        grupo: 'MENEGATTO-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 510,
    },
    {
        id: 'jnkd-4ghq-lpou-f6hu',
        //descricao: '',
        grupo: 'FATIMATEIXEIRA',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 520,
    },
    {
        id: 'yaqw-5gpk-fgem-kwga',
        //descricao: '',
        grupo: 'FATIMATEIXEIRA-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 530,
    },
    {
        id: 'mcxw-7ike-lpoy-qlfn',
        //descricao: '',
        grupo: 'FATIMATEIXEIRA-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 540,
    },
    {
        id: 'jueh-6yuj-wsqt-jopi',
        //descricao: '',
        grupo: 'MTOITO',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 550,
    },
    {
        id: 'nfrt-loi8-wplq-gets',
        //descricao: '',
        grupo: 'MTOITO-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 560,
    },
    {
        id: 'nbdw-pole-qsdf-3ft6',
        //descricao: '',
        grupo: 'MTOITO-08',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 570,
    },
    {
        id: 'nhue-olpe-3dfg-lowr',
        //descricao: '',
        grupo: 'TAUA-04',
        //subgrupo: 'DEZ24',
        //dataAssinaturaAte: '2024-12-31 00:00:00',
        //subgrupo: 'MAR25',
        //dataAssinaturaAte: '2025-03-31 00:00:00',
        subgrupo: 'OUT27',
        dataAssinaturaAte: '2027-10-31 00:00:00',
        ordem: 580,
    },
 ]
 
 export default codigoPromocionalList